import { getConversationById } from '@app/helpers'
import { ChatState, MessageUpdatedPayload } from '@app/hooks'
import { Message } from '@app/models'

export const onMessageUpdated = (
  state: ChatState,
  payload: MessageUpdatedPayload
): ChatState => {
  const { conversationId, message } = payload
  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation) {
    return state
  }
  const messageIndex = conversation.messages.findIndex(
    (item) => item.id === message.id
  )
  if (messageIndex === -1) {
    return state
  }

  const messages: Message[] = [
    ...conversation.messages.slice(0, messageIndex),
    message,
    ...conversation.messages.slice(messageIndex + 1),
  ]

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        messages,
      },
    },
  }
}
